import React from "react";
import {
  FormControl,
  FormErrorMessage,
  FormHelperText,
  FormLabel,
  Input,
  Select,
  Textarea,
} from "@chakra-ui/react";

export function UiField({ label, helper, error, isRequired, children, ...props }) {
  return (
    <FormControl isInvalid={!!error} isRequired={isRequired} {...props}>
      {label ? <FormLabel textStyle="eyebrow">{label}</FormLabel> : null}
      {children}
      {helper && !error ? (
        <FormHelperText textStyle="helper">{helper}</FormHelperText>
      ) : null}
      {error ? <FormErrorMessage>{error}</FormErrorMessage> : null}
    </FormControl>
  );
}

export function UiInput(props) {
  return <Input variant="outline" bg="surface.card" {...props} />;
}

export function UiSelect(props) {
  return <Select variant="outline" bg="surface.card" {...props} />;
}

export function UiTextarea(props) {
  return <Textarea variant="outline" bg="surface.card" {...props} />;
}
